import { render } from "./DataCollectionView.vue?vue&type=template&id=0a5c2ce6"
import script from "./DataCollectionView.vue?vue&type=script&lang=js"
export * from "./DataCollectionView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/bertog/Code/aitmes/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__